/**
 * API集中管理
 * 以业务模块划分
 * 命名格式：请求类型_接口名称，统一大写
 */

let base = ''
    // let base = 'https://qiguopt.qiguoiot.com/' //无代理修改为空

const api = {
    /**用户信息 */
    userInfo: {
        POST_APPLET: `${base}/api`, //设备列表
    }
};
export default api;